define('TescoMobile_DynamicBundleOptions/js/view/what-it-means',['uiComponent', 'ko', 'jquery', 'mage/translate', 'Magento_Catalog/js/price-utils', 'TescoMobile_Catalog/js/model/deal', 'priceBox'], function (Component, ko, $, $t, priceUtils, deal) {
  'use strict';

  return Component.extend({
    defaults: {
      template: 'TescoMobile_DynamicBundleOptions/what-it-means',
      pufAllOptionValue: null,
      tenure: 0,
      puf: 0,
      monthlyPhonePayment: 0,
      cashPrice: 0,
      interestRate: 0,
      arp: 0
    },
    initObservable: function () {
      this._super().observe(['tenure', 'puf', 'cashPrice', 'monthlyPhonePayment']);
      return this;
    },
    initialize: function () {
      this._super();
      $(document).on('DynamicOptionsPriceUpdateBefore', $.proxy(this._updateState, this));
      this.totalPhonePayment = ko.computed(function () {
        return parseFloat(this.monthlyPhonePayment()) * parseFloat(this.tenure()) + parseFloat(this.puf());
      }, this);
      this.creditAmount = ko.computed(function () {
        return this.totalPhonePayment() - this.puf();
      }, this);
      this.totalPaymentBreakdown = ko.computed(function () {
        return this.getFormattedPrice(this.monthlyPhonePayment) + ' x ' + this.tenure() + ' ' + $t('months') + ' + ' + this.getFormattedPrice(this.puf) + ' = ';
      }, this);
      $(document).trigger('selectDeviceOptionsEvent');
    },
    getTenure: function () {
      return this.tenure() + ' ' + $t('months');
    },
    getInterestRate: function () {
      return this.interestRate + '%';
    },
    getArp: function () {
      return this.arp + '%';
    },
    getFormattedPrice(price) {
      return priceUtils.formatPrice(price());
    },
    _updateState: function (event, data) {
      var newPuf = deal.puf === this.pufAllOptionValue ? deal.deviceFullPrice : deal.puf;
      var newTenure = deal.puf === this.pufAllOptionValue ? 0 : deal.tenure;
      var monthlyPhonePayment = deal.puf === this.pufAllOptionValue ? 0 : deal.deviceMonthlyPrice;
      this.puf(newPuf);
      this.tenure(newTenure);
      this.monthlyPhonePayment(monthlyPhonePayment);
      this.cashPrice(deal.deviceFullPrice);
    }
  });
});

